const VISITOR_ID_KEY = "portfolio_visitor_id";
const VISITOR_FIRST_SEEN_KEY = "portfolio_visitor_first_seen";
const VISITOR_COUNT_KEY = "portfolio_visit_count";

const createVisitorId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const markVisit = () => {
  const now = Date.now();
  const visitorId = localStorage.getItem(VISITOR_ID_KEY) || createVisitorId();
  const firstSeen = Number(localStorage.getItem(VISITOR_FIRST_SEEN_KEY)) || now;
  const visitCount = (Number(localStorage.getItem(VISITOR_COUNT_KEY)) || 0) + 1;

  localStorage.setItem(VISITOR_ID_KEY, visitorId);
  localStorage.setItem(VISITOR_FIRST_SEEN_KEY, String(firstSeen));
  localStorage.setItem(VISITOR_COUNT_KEY, String(visitCount));

  return { visitorId, firstSeen, lastSeen: now, visitCount };
};

export const getVisitor = () => ({
  visitorId: localStorage.getItem(VISITOR_ID_KEY) || createVisitorId(),
  firstSeen: Number(localStorage.getItem(VISITOR_FIRST_SEEN_KEY)) || Date.now(),
  visitCount: Number(localStorage.getItem(VISITOR_COUNT_KEY)) || 1,
});
